import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Appointment } from 'src/app/models/appointment.model';
import { Customer } from 'src/app/models/customer.model';
import { Horse } from 'src/app/models/horse.model';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'ubc-horse-select-create',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './horse-select-create.component.html',
  styleUrl: './horse-select-create.component.scss'
})
export class HorseSelectCreateComponent {
  @Input() appointment: Appointment
  @Output() horseSelected: EventEmitter<Horse | undefined> = new EventEmitter()
  createModeOn = false

  newHorseForm: FormGroup

  private modalEventSubscription: Subscription

  constructor(
    private modalService: ModalService
  ){}
  

  ngOnInit(){
    this.modalService.customer = this.appointment.customer

    this.modalEventSubscription = this.modalService.event$.subscribe((event) => {
      // Act upon the event here
      this.handleModalEvent(event);
    });
  }

  horseClicked(horse: Horse) {
    if(this.appointment.horse && horse.id === this.appointment.horse.id){
      this.appointment.horse = null
      
    } else {
    

    this.appointment.horse = horse
    }

    this.horseSelected.emit(this.appointment.horse)

  }

  newHorseClicked() {
    this.modalService.customer = this.appointment.customer
    this.modalService.openNewHorseModal()

    
  }

  horseEditClicked(event: MouseEvent, horse: Horse){
    event.stopPropagation();
    console.log("Edit Horse", horse)

    this.modalService.customer = this.appointment.customer
    this.modalService.openNewHorseModal(horse)
  }

  newHorseSubmitted(){
    
  }

  private handleModalEvent(event: any): void {
    if (event.type === 'CUSTOMER' && event.action === 'horses_updated') {
      console.log('Horses updated for customer:', event);
      
      const newHorse = event.newHorse;
      const horses = this.appointment.customer.horses;
  
      if (newHorse.id) {
        // look for an existing horse with the same id
        const idx = horses.findIndex(h => h.id === newHorse.id);
  
        if (idx > -1) {
          // replace the old horse object with the new one
          horses[idx] = newHorse;
        } else {
          // no matching id found? just add it
          horses.push(newHorse);
        }
  
      } else {
        // brand‑new horse (no id yet)
        horses.push(newHorse);
      }
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.modalEventSubscription) {
      this.modalEventSubscription.unsubscribe();
    }
  }

  
}
